import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../context/auth'
import { requestOpenChat } from '../utils/chatState'

const PushBridge = () => {
  const navigate = useNavigate()
  const { auth } = useAuthContext()
  const hasToken = Boolean(auth?.accessToken)

  // A notification was clicked while the app was already open
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    const onMessage = (e) => {
      if (e.data?.type !== 'open-chat') return
      if (e.data.convId) requestOpenChat(e.data.convId)
      navigate('/chat')
    }

    navigator.serviceWorker.addEventListener('message', onMessage)
    return () => navigator.serviceWorker.removeEventListener('message', onMessage)
  }, [navigate])

  // The app was started by clicking a notification: /chat?open=<chat id>
  useEffect(() => {
    if (!hasToken) return

    const id = new URLSearchParams(window.location.search).get('open')
    if (!id) return

    requestOpenChat(id)
    navigate('/chat', { replace: true })       // removes ?open= from the address
  }, [hasToken, navigate])

  return null
}

export default PushBridge